module.exports = "<div>\n\t<div class=\"map\" id=\"chartdiv\"></div>\n</div>"